import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx } from 'react/jsx-runtime';
import React, { createContext, useContext, useState } from 'react';

const RealtimeSectionsContext = /*#__PURE__*/createContext({});
const useRealtimeSections = () => {
  return useContext(RealtimeSectionsContext);
};
function reducer(state, action) {
  switch (action.type) {
    case 'add':
      return {
        sections: action.sections
      };
    case 'update':
      return {
        sections: state.sections.map(section => Object.assign(Object.assign({}, section), {
          progress: section.id === action.sectionId && (action === null || action === void 0 ? void 0 : action.sectionProgress) !== undefined ? action.sectionProgress : section.progress,
          posts: section.id === action.sectionId ? section.posts.map(post => {
            var _a, _b, _c;
            if (post.id === action.postId) {
              return Object.assign(Object.assign({}, post), {
                viewed: (action === null || action === void 0 ? void 0 : action.viewed) !== undefined ? action.viewed : post.viewed,
                cover: Object.assign(Object.assign({}, post.cover), {
                  progress: Object.assign(Object.assign({}, (_a = post.cover) === null || _a === void 0 ? void 0 : _a.progress), {
                    currentProgress: action.currentTime ? action.currentTime : (_c = (_b = post.cover) === null || _b === void 0 ? void 0 : _b.progress) === null || _c === void 0 ? void 0 : _c.currentProgress
                  })
                })
              });
            }
            return post;
          }) : section.posts
        }))
      };
    default:
      throw new Error();
  }
}
const initialState = {
  sections: []
};
const CreateRealtimeSectionsProvider = props => {
  const [realtimePostProgress, setRealtimePostProgress] = useState(0);
  const [realtimeState, dispatch] = React.useReducer(reducer, initialState);
  const value = {
    realtimePostProgress,
    setRealtimePostProgress,
    sections: realtimeState.sections,
    dispatch
  };
  return jsx(RealtimeSectionsContext.Provider, Object.assign({
    value: value
  }, {
    children: props.children
  }));
};

export { CreateRealtimeSectionsProvider, RealtimeSectionsContext, useRealtimeSections };
